import { render, staticRenderFns } from "./VodStatisticsView.vue?vue&type=template&id=76fdeb18&scoped=true"
import script from "./VodStatisticsView.vue?vue&type=script&lang=js"
export * from "./VodStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fdeb18",
  null
  
)

export default component.exports